import React from 'react';
import { useFormContext } from 'react-hook-form';

import * as styled from './styles';

type Props = {
  name: string;
  label?: string;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  disabled?: boolean;
};

export const FormTextArea = ({ name, label, rows = 3, ...rest }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name]?.message as string | undefined;

  return (
    <styled.Field>
      {label && <styled.Label>{label}</styled.Label>}
      <styled.Textarea
        {...register(name)}
        rows={rows}
        $hasError={!!error}
        aria-invalid={!!error}
        {...rest}
      />
      {error && <styled.ErrorText>{error}</styled.ErrorText>}
    </styled.Field>
  );
};
